const defaultState = {
  customerGroup: {},
  error: null,
  saving: false,
  saved: false
};

const addEditCustomerGroupReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_EDIT_CUSTOMER_GROUP_SAVE_PENDING': {
      return {
        ...state, saving: true, error: null
      };
    }
    case 'ADD_EDIT_CUSTOMER_GROUP_SAVE_FULFILLED': {
      return {
        ...state, saving: false, error: null, saved: true, newCustomerGroup: action.payload
      };
    }
    case 'ADD_EDIT_CUSTOMER_GROUP_SAVE_REJECTED': {
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default addEditCustomerGroupReducer;


// WEBPACK FOOTER //
// ./src/reducers/addEditCustomerGroup.js